import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import classnames from 'classnames'
import { Button } from 'react-bootstrap';
import PatchOps from '@leverege/api-patch-ops'
import pathUtil from '@leverege/path'
import { Text, Label } from '@leverege/ui-elements'

import { TimerActions, BreadcrumbActions, NotifyActions, Constants } from '~/actions'
import { TimerFactory } from '../../editors/timer'
import { TimerActionFactory } from '../../editors/timerAction'

import { List, SplitPane, Screen, TextInput, LabelGroup, Loading } from '~/views'
import PaginationSearch from '../utils/PaginationSearch'
import TimerItem from './TimerItem'

import style from './style.css'

class TimersScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }

  constructor( props, context ) {
    super( props, context )
    this.pager = new PaginationSearch( this, 'timers', ( props, opts ) => {
      this.props.dispatch( TimerActions.list( this.props.match.params.projectId, opts ) )
    } )
    this.state = { 
      selectId : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props ) 
    }
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Timers' } ] ) )
  }

  componentWillReceiveProps( next ) {
    this.pager.loadIfNeeded( next )
  }

  onCreateTimer = () => {
    const { params } = this.props.match
    if ( params && params.projectId ) {
      this.props.dispatch( TimerActions.create(
        params.projectId,
        {
          name : 'My Timer',
          timer : TimerFactory.defaults[Object.keys( TimerFactory.defaults )[0]],
          action : TimerActionFactory.defaults[Object.keys( TimerActionFactory.defaults )[0]]
        } 
      ) )
    }
  }

  onEvent = ( evt, item ) => {
    const { dispatch, match } = this.props
    const { params } = match
    switch ( evt ) {
      case TimerItem.STOP_EVENT:
        dispatch( TimerActions.stop(
          params.projectId,
          item
        ) )
        break
      case TimerItem.START_EVENT:
        dispatch( TimerActions.start(
          params.projectId,
          item
        ) )
        break
      case TimerItem.REMOVE_EVENT:
        dispatch( TimerActions.delete(
          params.projectId,
          item
        ) )
        break
      case TimerItem.SELECTED:
        if ( item && item.id ) {
          this.setState( { selectId : item.id === this.state.selectId ? null : item && item.id } )
        }
        break
    }
  }

  onTimerChange = ( { path, target, value }, override ) => {
    const { dispatch, match } = this.props
    const projectId = match.params && match.params.projectId
    if ( path === 'timer/type' && target.timer.type !== value ) {
      const patchOps = PatchOps().replace( 'timer', TimerFactory.defaults[value] ).ops()
      dispatch( TimerActions.update( projectId, target, patchOps ) )
    } else if ( path.startsWith( 'timer/' ) ) {
      const newTimer = { ...target, timer : { ...target.timer } }
      pathUtil( path ).set( newTimer, value )
      if ( path == 'timer/delay' ) {
        delete newTimer.timer.when
      } else if ( path == 'timer/when' ) {
        delete newTimer.timer.delay
      }
      const patchOps = PatchOps().replace( 'timer', newTimer.timer ).ops()
      dispatch( TimerActions.update( projectId, target, patchOps ) )
    } else if ( path === 'action/type' && ( target.action.type !== value || override ) ) {
      const patchOps = PatchOps().replace( 'action', TimerActionFactory.defaults[value] ).ops()
      dispatch( TimerActions.update( projectId, target, patchOps ) )
    } else if ( path.startsWith( 'action/' ) ) {
      // replace whole action
      const newTimer = { ...target, action : { ...target.action } }
      pathUtil( path ).set( newTimer, value )
      const patchOps = PatchOps().replace( 'action', newTimer.action ).ops()
      dispatch( TimerActions.update( projectId, target, patchOps ) )
    } else {
      const patchOps = PatchOps().replace( path, value ).ops()
      dispatch( TimerActions.update( projectId, target, patchOps ) )
    }
  }

  onTimerError = ( path, value, err ) => {
    this.props.dispatch( NotifyActions.error( err.message, value, path ) )
  }

  render() {
    const { selectId, search, start } = this.state
    const { timers, projects } = this.props
    const { params } = this.props.match

    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()
    const projectId = params && params.projectId

    const isSelected = ( item ) => {
      return selectId === ( item && item.id )
    }
    const loading = timers.status == Constants.STATUS_LOADING
    const items = timers.projectId == projectId ? this.pager.getPageItems() : []

    let selectItem = null
    items.forEach( ( item ) => {
      if ( selectId === item.id ) selectItem = item
    } )
    const editor = TimerFactory.createEditor( 
      selectItem,
      { 
        onChange : this.onTimerChange,
        onError : this.onTimerError,
        currentContext : {
          projectId : params && params.projectId,
          systemId : params && params.systemId,
          scriptId : params && params.scriptId,
          deviceId : params && params.deviceId
        }
      }
    )

    const left = (
      <div className={style.left}>
        <SplitPane className={style.timerSplit}
          left={(
            <List className={classnames( style.list, style.splitLeft )}
              onEvent={this.onEvent} 
              isSelected={isSelected}
              noItemsView={loading ? null : <div className={style.noItems}>You have no Timers</div>}
              items={items}
              itemView={TimerItem}
              itemProps={{ hideNavButtons : false }} />
          )}
          right={(
            <div className={style.splitRight}> 
              {' '}
              { editor }
              {' '}
            </div>
          )} />
        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Timers</Text>
          <div className={style.flexRight} style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <Label><i className="fa fa-search" /></Label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={this.onCreateTimer}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Timer
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {left}
        </Screen.Content>
      </Screen>
    )
  }
}

export default connect(
  state => ( {
    timers : state.timers,
    projects : state.projects
  } )
)( TimersScreen );
